export interface CategoryInterface {
  id: number;
  order: number;
  name: string;
  parentId: number | null;
}

export interface ExtendedCategoryInterface extends CategoryInterface {
  activeImg: string | undefined;
  inactiveImg: string | undefined;
  to: string;
}

export interface CategoryState {
  isLoading: boolean;
  error: string | undefined;
  data: {
    categories: CategoryInterface[] | [];
  };
}

export interface CategoriesPropsInterface {
  activeCategoryId: number | null;
  setActiveCategory: (category: CategoryInterface) => void;
}

export const optionsWhitelistedParentIds: string[] = ["1", "2"];
